import React, { useEffect, useState } from 'react';
import classes from "./CategoryPage.module.css";
import { FaArrowLeft, FaBarsStaggered } from 'react-icons/fa6';
import Lottie from 'lottie-react';
import stars from "../animations/stars3.json";
import { getVideosApi } from '../http/http';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Player/UI/Loader/Loader';
import Spinner from '../components/Player/UI/Loader/Spinner';

const CategoryPage = () => {
    const params = useParams();
    console.log(params, "params.....");

    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(true);

    const navigate = useNavigate();

    const fetchVideos = async () => {
        try {
            setLoader(true);
            const response = await getVideosApi();

            let filteredData = response?.data.filter((item) => item?.category?.toLowerCase() == params?.category_name?.toLowerCase())?.[0]?.data;
            console.log(filteredData, 'fd');
            if (filteredData?.length <= 0 || !filteredData) {
                navigate("/");
            }

            setData(filteredData);
            setLoader(false);
            console.log(response, 'response====');

        } catch (error) {
            setLoader(false);

            console.log(error, 'error---');
        }
    }

    useEffect(() => {
        if (params?.category_name) {
            fetchVideos();
        }
    }, [params]);

    console.log(data, 'datas-------');

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <FaArrowLeft className="back-icon" style={{ color: "#1C1F26" }} onClick={() => navigate("/home")} />
                    <div className={classes.logo_container}
                        onClick={() => {
                            navigate("/home");
                        }}
                    >
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                </nav>
                <div className={classes.category_items_container}>

                    <div className={classes.category_items}>
                        <button type="button"
                            onClick={() => {
                                navigate("/category/rhymes");
                            }}
                            className={`${classes.category_item} ${params?.category_name?.toLowerCase() === "rhymes" && classes.active}`}>
                            Rhymes
                        </button>

                        <button type="button"
                            onClick={() => {
                                navigate("/category/learning");
                            }}
                            className={`${classes.category_item} ${params?.category_name?.toLowerCase() === "learning" && classes.active}`}>
                            Learning
                        </button>

                        <button type="button"
                            onClick={() => {
                                navigate("/category/stories");
                            }}
                            className={`${classes.category_item} ${params?.category_name?.toLowerCase() === "stories" && classes.active}`}>
                            Stories
                        </button>
                    </div>
                </div>
            </header>

            <section className={classes.section_landing_page}>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

                {loader ? (<>
                    <Spinner />
                </>) : (<>
                    <Lottie
                        animationData={stars}
                        loop={true}
                        autoplay={true}
                        initialSegment={[0, 100]}
                        className={classes.background_animation}
                    />

                    <div className={classes.container}>
                        <div className={classes.grid_container}>
                            {data?.map((item, index) => {
                                return (
                                    <div className={classes.grid_item} key={index}
                                        onClick={() => {
                                            navigate("/category/video/play", {
                                                state: {
                                                    data: data,
                                                    video: item
                                                }
                                            })
                                        }}
                                    >
                                        <div className={classes.grid_sub_item}>
                                            <img src={item?.image_link} alt={item?.video_name} className={classes.item_image} />

                                            <div className={classes.grid_item_description}>
                                                <h1 className={classes.video_name}>
                                                    {item?.video_name}
                                                </h1>
                                            </div>
                                        </div>
                                        <button type="button" className={classes.watch_button}>
                                            Watch
                                        </button>
                                    </div>
                                )
                            })}

                        </div>

                    </div>
                </>)}



            </section>

        </main>
    )
}

export default CategoryPage